import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  /**
   * Retrieves an item from Local Storage.
   * @param key The key of the item to retrieve.
   * @returns The parsed JSON object or null if not found.
   */
  getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error(`Error parsing Local Storage key "${key}":`, error);
      return null;
    }
  }

  /**
   * Saves an item to Local Storage.
   * @param key The key under which to store the item.
   * @param value The value to store.
   */
  setItem<T>(key: string, value: T): void {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error(`Error setting Local Storage key "${key}":`, error);
    }
  }

  /**
   * Removes an item from Local Storage.
   * @param key The key of the item to remove.
   */
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing Local Storage key "${key}":`, error);
    }
  }

  /**
   * Clears all items from Local Storage.
   */
  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing Local Storage:', error);
    }
  }
}
